import { defineRule, configure } from 'vee-validate'
import { all } from '@vee-validate/rules'
import { localize, setLocale } from '@vee-validate/i18n'

Object.keys(all).forEach((rule) => {
  defineRule(rule, all[rule])
})

// defineRule('test', (value, params) => {
//   return value || true
// })

configure({
  generateMessage: localize({
    en: {
      messages: {
        required: (field) => field + ' should not be empty.',
        min: (field, args) => field + ' should be more than ' + args + ' alphamunerics.',
        max: (field, args) => field + ' should be less than ' + args + ' alphamunerics.',
        digits: (field, args) => field + ' should be ' + args + ' digit',
        min_value: (field, args) => field + ' should be more than ' + args,
        max_value: (field, args) => field + ' should be less than ' + args,
        integer: (field) => field + ' should be integer',
        mimes: (field, args) => field + ' should be mime ' + args,
        ext: (field, args) => field + ' should be extension ' + args,
        dimensions: (field, args) => field + ' should be ' + args,
        regex: (field) => 'The ' + field + ' is incorrect.',
        email: () => 'Please enter right email format.'
      }
    },
    tc: {
      messages: {
        required: validation => validation.field + ' 欄位必填',
        min: validation => validation.field + ' 最少 ' + validation.rule.params[0] + ' 個字',
        max: validation => validation.field + ' 不得超過 ' + validation.rule.params[0] + ' 個字',
        digits: validation => validation.field + ' 請輸入 ' + validation.rule.params[0] + ' 位數字',
        min_value: validation => validation.field + ' 不得低於 ' + validation.rule.params[0],
        max_value: validation => validation.field + ' 不得超過 ' + validation.rule.params[0],
        integer: validation => validation.field + ' 必須為整數',
        mimes: validation => validation.field + ' 必須符合MIME類型 ' + validation.rule.params[0],
        ext: validation => validation.field + ' 必須符合檔案類型 ' + validation.rule.params[0],
        dimensions: validation => validation.field + ' 寬與高須分別為 ' + validation.rule.params[0],
        regex: validation => '無效的 ' + validation.field,
        email: validation => validation.field + ' 請輸入正確Email格式'
      }
    }
  })
})
setLocale('tc')
